import { restDefaultHandlers } from '@hotjar/webapp/utils/rest-default-handlers';

/**
 * @deprecated Use the new module instead of this service
 * @todo Remove this service as soon as the React migration has finished
 *       or its usage has been fully replaced by directly using the new
 *       module.
 */
angular.module('hjApp.api').factory('restDefaultHandlers', () => restDefaultHandlers);
